import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface StopCanceledProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function StopCanceled({ color = RoutalPalette.secondary60, style = {} }: StopCanceledProps) {
  return (
    <SvgIcon width="12" height="12" viewBox="0 0 12 12" style={{ height: `16px`, width: `16px`, ...style }}>
      <g>
        <path
          fill={color}
          strokeWidth="0px"
          d="M10.8,4.23c0,3.56-3.72,6.79-4.61,7.51-.11.09-.27.09-.38,0-.89-.73-4.61-3.99-4.61-7.51C1.2,2,3.35.19,6,.19s4.8,1.81,4.8,4.04Z"
        />
        <path fill="none" stroke="#fafafa" strokeLinecap="round" strokeLinejoin="round" d="M7.9,2.96l-3.8,3.8" />
        <path fill="none" stroke="#fafafa" strokeLinecap="round" strokeLinejoin="round" d="M4.1,2.96l3.8,3.8" />
      </g>
    </SvgIcon>
  );
}
